import { Component, OnInit } from '@angular/core';
import { PolicyService } from 'app/services/policy-service';
import { ChatService } from 'app/services/chat-service';
import { ToastrService } from 'ngx-toastr';
import { CommonsText } from 'app/commons/CommonsText';

interface MediatorProduct {
    code: string;
    label: string;
    name: string;
    phone: string;
    phone2?: string;
    email: string;
}

@Component({
    selector: 'app-profile-support',
    templateUrl: './profile-support.component.html',
    styleUrls: ['./profile-support.component.scss']
})
export class ProfileSupportComponent implements OnInit {

    products: MediatorProduct[] = [];
    selected: MediatorProduct;
    open = false;
    loading = false;

    // Nº de póliza (secuencia) de las pólizas de tipo "Asistencia Jurídica Familiar" (DJ29)
    // del usuario. Puede haber 0 o N. El servicio de mediadores (los que rellenan el
    // desplegable "Selecciona un producto") no devuelve el productId de cada póliza, así
    // que se obtiene por separado vía /policies/search filtrando por producto, y luego se
    // cruza por número de póliza con el producto seleccionado en el combo.
    private legalAssistancePolicySequences: Set<string> = new Set();

    constructor(private policyService: PolicyService, private chatService: ChatService,
                private toastr: ToastrService) {}

    ngOnInit(): void {
        this.loading = true;
        this.policyService.getMediators()
            .then(success => {
                const list = (success && success.response) ? success.response : [];
                this.products = list.map(item => ({
                    code: item.id,
                    label: item.itemName,
                    name: '',
                    phone: '',
                    email: ''
                } as MediatorProduct));
                this.loading = false;
                if (this.products.length > 0) {
                    this.select(this.products[0]);
                }
            })
            .catch(() => {
                this.products = [];
                this.loading = false;
                this.toastr.error(CommonsText.PROBLEMA_SERVICIO_MEDIADORES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                    timeOut: 5000
                });
            });

        this.loadLegalAssistancePolicies();
    }

    private loadLegalAssistancePolicies(): void {
        this.policyService.getLegalAssistancePolicies()
            .then((list: any[]) => {
                this.legalAssistancePolicySequences = new Set(
                    (list || []).map(policy => this.sequenceFromPolicyNumber(policy.number)).filter(seq => !!seq)
                );
            })
            .catch(() => {
                this.legalAssistancePolicySequences = new Set();
            });
    }

    // PolicyDTO.number es la secuencia de la póliza (ver
    // SearchPageablePoliciesBySpringUserCoreCmd.parseResponse).
    private sequenceFromPolicyNumber(policyNumber: string): string {
        if (!policyNumber) {
            return null;
        }
        return policyNumber;
    }

    // El "code" del combo viene como "{sequence}/{mediatorId}" (ver
    // RetrieveMediatorsByEntityAndSpringUserCoreCmd.parseResponse) -> la secuencia es la 1ª parte.
    private sequenceFromMediatorCode(code: string): string {
        if (!code) {
            return null;
        }
        return code.split('/')[0];
    }

    isLegalAssistanceSelected(): boolean {
        if (!this.selected) {
            return false;
        }
        return this.legalAssistancePolicySequences.has(this.sequenceFromMediatorCode(this.selected.code));
    }

    // El botón de chat solo se muestra cuando el producto seleccionado es DJ29
    // (isLegalAssistanceSelected), así que se compone el payload con la póliza (secuencia)
    // de ese producto antes de abrir el widget.
    openChat(): void {
        const policySequence = this.sequenceFromMediatorCode(this.selected ? this.selected.code : '');
        this.chatService.openChatWithContext(policySequence);
    }

    toggleDropdown(): void {
        this.open = !this.open;
    }

    select(p: MediatorProduct): void {
        this.selected = p;
        this.open = false;
        this.policyService.getMediator(p.code)
            .then(success => {
                const mediator = (success && success.response) ? success.response : {};
                p.name = mediator.name || '';
                p.phone = mediator.phone1 || '';
                p.phone2 = mediator.phone2 || undefined;
                p.email = mediator.email || '';
            })
            .catch(() => {
                this.toastr.error(CommonsText.PROBLEMA_SERVICIO_MEDIADORES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                    timeOut: 5000
                });
            });
    }
}
